import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_store_management-account_settings_stores_link-view';
/**
 * Event that gets fired when the user views the &quot;Stores&quot; link leading to the Stores page in the account settings.
 */
export function trackRetailerStoreManagementAccountSettingsStoresLinkView() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: true,
    });
}
